import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth-service/auth-service.service';
import { ApplicationInformation } from './application-information.model';


@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(private httpClient: HttpClient,
    private authService: AuthService
  ) { }

  apiVersion = signal<string>('');

  getAPIVersion() {
    let headers = new HttpHeaders(
      { 'Authorization': 'Bearer ' + this.authService.getAccessToken(), 'AuthSession': this.authService.getSessionToken() }
    );

    return this.httpClient.get<ApplicationInformation>(environment.apiUrl + `/api/info`, { headers: headers });
  }

  setAPIVersion(APIVersion: string) {
    this.apiVersion.set(APIVersion);
  }


}